// components/ui/LevelDot.js — small colored dot for status/level indication.
// Use as a quiet color cue in dense lists/tables. Sizes: sm (1.5x1.5), md (2x2).
import React from 'react';

const COLORS = {
  good:    'bg-status-good',     // emerald
  warn:    'bg-status-warn',     // amber
  bad:     'bg-status-bad',      // red
  info:    'bg-status-info',     // sky
  neutral: 'bg-faint',
  faint:   'bg-surface-subtle',
};

const SIZES = {
  sm: 'w-1.5 h-1.5',
  md: 'w-2 h-2',
  lg: 'w-2.5 h-2.5',
};

export default function LevelDot({ color = 'neutral', size = 'sm', className = '' }) {
  return (
    <span
      className={`inline-block rounded-full flex-shrink-0 ${COLORS[color]} ${SIZES[size]} ${className}`}
    />
  );
}
